(function () {
  if (!window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SEL = 'a[href], button, [role="button"], summary, input[type="submit"], input[type="button"], input[type="checkbox"], input[type="radio"], label[for], select, [data-tf-popup], [data-tf-slider], .button';
  function star() { return '<img src="' + (window.BX_STAR || '') + '" alt="" width="38" height="38" draggable="false">'; }
  var el = document.createElement('div');
  el.className = 'bx-cursor'; el.setAttribute('aria-hidden', 'true'); el.innerHTML = star();
  var x = -100, y = -100, cx = x, cy = y, on = false, rot = 0, raf = 0, html = document.documentElement;
  function tick() {
    cx += (x - cx) * .35; cy += (y - cy) * .35;
    if (!reduced) rot += on ? .9 : 0;
    el.style.transform = 'translate3d(' + (cx - 14) + 'px,' + (cy - 14) + 'px,0) rotate(' + rot + 'deg) scale(' + (on ? 1 : .7) + ')';
    if (on || Math.abs(x - cx) > .3 || Math.abs(y - cy) > .3) raf = requestAnimationFrame(tick); else raf = 0;
  }
  function kick() { if (!raf) raf = requestAnimationFrame(tick); }
  function set(v) { if (v === on) return; on = v; el.classList.toggle('is-on', v); html.classList.toggle('bx-hover', v); kick(); }
  document.addEventListener('pointermove', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    x = e.clientX; y = e.clientY;
    if (!el.parentNode) document.body.appendChild(el);
    var t = e.target && e.target.closest ? e.target.closest(SEL) : null;
    if (t && (t.disabled || t.getAttribute('aria-disabled') === 'true')) t = null;
    if (t) {
      var r = t.getBoundingClientRect();
      if (e.clientX < r.left - 4 || e.clientX > r.right + 4 || e.clientY < r.top - 4 || e.clientY > r.bottom + 4) t = null;
    }
    if (t) {
      if (r.width * r.height > window.innerWidth * window.innerHeight * .25 || /overlay|scrim|backdrop/i.test(t.className + ' ' + (t.id || ''))) t = null;
    }
    set(!!t); kick();
  }, { passive: true });
  document.addEventListener('mouseleave', function () { set(false); });
  window.addEventListener('blur', function () { set(false); });
})();
